import { render, staticRenderFns } from "./SliceParagraphsWithSidebar.vue?vue&type=template&id=012e3892&scoped=true"
import script from "./SliceParagraphsWithSidebar.vue?vue&type=script&lang=js"
export * from "./SliceParagraphsWithSidebar.vue?vue&type=script&lang=js"
import style0 from "./SliceParagraphsWithSidebar.vue?vue&type=style&index=0&id=012e3892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e3892",
  null
  
)

export default component.exports